module.exports = __webpack_public_path__ + "img/eggsgame.9caf204b.webp";